import React from "react"
import PropTypes from "prop-types"
import localAuthorities from './localAuthorities';


class DemographicsForm extends React.Component {
  constructor(props) {
    super(props);
  }

  render () {

    // YEARS

    let years = [];

    for(let i = 1900; i < (new Date()).getFullYear(); i++){
      const option = <option key={i} value={i}>{i}</option>
      years.push(option);
    }

    years = years.reverse();

    // LOCAL AUTHORITIES

    const authorities = localAuthorities.map((l, i) => (
      <option value={l} key={l}>{l}</option>
    ))


    return (
      <div
        ref={this.props.innerRef}
        id='demographics'
        className='mpl mpr lpb flex-container align-center transparent grid-x'
      >
        <div className='cell medium-8 large-6'>
          <form className='flex-container flex-dir-column align-center'>

            <label
              htmlFor="year_of_birth"
              className='h4'
            >
              What year were you born?
            </label>

            <select
              name="year_of_birth"
              id="select-year-of-birth"
              onChange={this.props.handleSelectChange}
              defaultValue='Choose a year ...'
            >
              {years}
            </select>

            <label
              htmlFor="area_type"
              className='h4'
            >
              What kind of area do you live in?
            </label>

            <select
              name="area_type"
              id="select-area-type"
              onChange={this.props.handleSelectChange}
            >
              <option disabled selected value="#">Please choose...</option>
              <option value="City/Town">City/Town</option>
              <option value="Village">Village</option>
              <option value="Rural">Rural</option>
            </select>

            <label
              className='h4'
              htmlFor="local_authority"
            >
              What Local Authority area do you live in?
            </label>

            <select
              name="local_authority"
              id="select-local-authority"
              onChange={this.props.handleSelectChange}
            >
              <option value="" disabled selected>Please choose...</option>
              {authorities}
            </select>

            <button
              className='button expanded mmt'
              onClick={this.props.submitSurvey}
            >
              <h3>
                Submit
              </h3>
            </button>
          </form>
        </div>
      </div>
    );
  }
}

export default React.forwardRef((props, ref) => <DemographicsForm
  innerRef={ref} {...props}
/>);
